// Maps the calculator's tier label to the "Top X% of tracked deals" headline
// per FR-014. Percentile bands come from the 55-deal calibration distribution
// (REVENUE_MODELS_EXAMPLES.md / ALL_DEALS_TABLE.md).
//
// These are *cumulative* percentiles from the top: Ultra-Premium is the top
// 8% by deal-tier frequency, Premium is the top 20% (8 + 12), and so on.
// We surface only the upper bound — never the raw adjusted-value score.

const TIER_TOP_PERCENT = {
  'Ultra-Premium': 8,
  Premium: 20,
  'High-Value': 35,
  Standard: 55,
  Competitive: 80,
  Entry: 100,
};

// tierHeadline('Premium') => "Top 20% of tracked deals"
export function tierHeadline(tier) {
  const pct = TIER_TOP_PERCENT[tier];
  if (pct === undefined) return '';
  if (pct >= 100) return 'Across the breadth of tracked deals';
  return `Top ${pct}% of tracked deals`;
}

// tierTopPercent('Ultra-Premium') => 8. Returns null for unknown tiers so
// callers can branch instead of getting NaN downstream.
export function tierTopPercent(tier) {
  const pct = TIER_TOP_PERCENT[tier];
  return pct === undefined ? null : pct;
}

// ordered list of tiers from lowest to highest — handy for legend rendering.
export const TIERS_LOW_TO_HIGH = [
  'Entry',
  'Competitive',
  'Standard',
  'High-Value',
  'Premium',
  'Ultra-Premium',
];
